class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    const facetForm = this.querySelector('form');
    if (!facetForm) return;

    if (facetForm.id === 'FacetFiltersFormMobile') {
      this.onMobileFilterInput = this.onMobileFilterInput.bind(this);
      facetForm.addEventListener('input', this.onMobileFilterInput);
      facetForm.addEventListener('change', this.onMobileFilterInput);
    } else {
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 800);
      facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = '.facets__summary';
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(documentFromFetch) {
    const resolvedHTML =
      typeof documentFromFetch === 'string'
        ? new DOMParser().parseFromString(documentFromFetch, 'text/html')
        : documentFromFetch;

    const openFetched = resolvedHTML.querySelector('.mobile-facets__open');
    const openDom = document.querySelector('.mobile-facets__open');
    if (openFetched && openDom) openDom.innerHTML = openFetched.innerHTML;

    ['.facets-toolbar__trigger--filter', '.facets-toolbar__trigger--sort'].forEach((selector) => {
      const fetched = resolvedHTML.querySelectorAll(selector);
      const dom = document.querySelectorAll(selector);
      fetched.forEach((node, i) => {
        if (dom[i]) dom[i].textContent = node.textContent;
      });
    });

    const countFetched = resolvedHTML.querySelector('.mobile-facets__count');
    const countDom = document.querySelector('.mobile-facets__count');
    if (countFetched && countDom) countDom.innerHTML = countFetched.innerHTML;

    const hTitleFetched = resolvedHTML.querySelector('.facets-filter-panel__title');
    const hTitleDom = document.querySelector('.facets-filter-panel__title');
    if (hTitleFetched && hTitleDom) hTitleDom.textContent = hTitleFetched.textContent;

    FacetFiltersForm.syncSortDrawerFromFetch(resolvedHTML);

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    mobileForm?.closest('menu-drawer')?.bindEvents();
  }

  static syncSortDrawerFromFetch(parsedHTML) {
    ['FacetsSortForm'].forEach((id) => {
      const fetchedRoot = parsedHTML.getElementById(id);
      const domRoot = document.getElementById(id);
      if (!fetchedRoot || !domRoot) return;
      const srcSync = fetchedRoot.querySelector('.facet-drawer-sort-form__sync');
      const tgtSync = domRoot.querySelector('.facet-drawer-sort-form__sync');
      if (srcSync && tgtSync) tgtSync.innerHTML = srcSync.innerHTML;
    });

    const srcList = parsedHTML.querySelector('[id^="FacetsSortModalList-"]');
    const tgtList = document.querySelector('[id^="FacetsSortModalList-"]');
    if (srcList && tgtList) tgtList.innerHTML = srcList.innerHTML;
  }

  static updateFilterPanelCounts(form = document.getElementById('FacetFiltersFormMobile')) {
    if (!form) return;

    form.querySelectorAll('.js-filter').forEach((filterGroup) => {
      const summaryInner = filterGroup.querySelector('.facets-filter-panel__summary-inner');
      if (!summaryInner) return;

      let count = 0;
      const priceRange = filterGroup.querySelector('price-range');

      if (priceRange) {
        const [minInput, maxInput] = priceRange.querySelectorAll('input');
        if (minInput?.value.trim() || maxInput?.value.trim()) count = 1;
      } else {
        count = filterGroup.querySelectorAll(
          'input.mobile-facets__checkbox:checked, input.swatch-input__input:checked'
        ).length;
      }

      let infoEl = summaryInner.querySelector('.facets-filter-panel__info');
      if (count > 0) {
        if (!infoEl) {
          infoEl = document.createElement('span');
          infoEl.className = 'facets-filter-panel__info';
          summaryInner.appendChild(infoEl);
        }
        infoEl.textContent = count;
      } else if (infoEl) {
        infoEl.remove();
      }

      filterGroup.querySelectorAll('input.mobile-facets__checkbox, input.swatch-input__input').forEach((input) => {
        const option = input.closest('.facets-filter-panel__option, .mobile-facets__label');
        if (option) option.classList.toggle('active', input.checked);
      });
    });
  }

  onMobileFilterInput(event) {
    FacetFiltersForm.updateFilterPanelCounts(event.target.closest('form'));
  }

  static initMobileFilterApply() {
    if (FacetFiltersForm.applyDelegated) return;
    FacetFiltersForm.applyDelegated = true;

    document.addEventListener('click', (event) => {
      const applyBtn = event.target.closest('.js-facets-apply');
      if (!applyBtn) return;

      const filtersForm = applyBtn.closest('#FacetFiltersFormMobile');
      if (!filtersForm) return;

      const facetFiltersFormEl = applyBtn.closest('facet-filters-form');
      if (!facetFiltersFormEl) return;

      const sortForm = document.getElementById('FacetsSortForm');
      const params = [facetFiltersFormEl.createSearchParams(filtersForm)];
      if (sortForm) params.push(facetFiltersFormEl.createSearchParams(sortForm));

      facetFiltersFormEl.onSubmitForm(params.join('&'), event);
      applyBtn.closest('.mobile-facets__wrapper')?.querySelector('summary')?.click();
    });
  }

  static initSortDrawerModal() {
    if (FacetFiltersForm.sortDrawerDelegated) return;
    FacetFiltersForm.sortDrawerDelegated = true;

    document.addEventListener('click', (event) => {
      const filterClose = event.target.closest?.('.facets-filter-panel__close, .mobile-facets__close-btn');
      if (filterClose) return;

      const backdrop = event.target.closest?.('.facets-sort-drawer-modal__backdrop');
      const closeBtn = event.target.closest?.('.facets-sort-drawer-modal__close-btn');
      let detailsModal = backdrop?.closest?.('details.facets-sort-drawer-modal');

      if (closeBtn && !detailsModal) {
        detailsModal = closeBtn.closest('details.facets-sort-drawer-modal');
      }

      if (detailsModal && (backdrop === event.target || closeBtn)) {
        detailsModal.removeAttribute('open');
        event.preventDefault();
        return;
      }

      const optionBtn = event.target.closest?.('[data-sort-value].facets-sort-drawer-modal__option');
      if (!optionBtn) return;

      const sortValue = optionBtn.dataset.sortValue;
      const detailsRoot = optionBtn.closest('details.facets-sort-drawer-modal');
      const select =
        detailsRoot?.closest('form')?.querySelector('select[name="sort_by"]') ||
        detailsRoot?.closest('facet-filters-form')?.querySelector('form select[name="sort_by"]') ||
        document.querySelector('#FacetsSortForm select[name="sort_by"]') ||
        document.querySelector('#FacetSortForm select[name="sort_by"]');
      if (!select || sortValue === undefined || !detailsRoot) return;

      select.value = sortValue;
      select.dispatchEvent(new Event('input', { bubbles: true }));

      detailsRoot.querySelectorAll('.facets-sort-drawer-modal__option').forEach((el) => {
        const active = el === optionBtn;
        el.classList.toggle('is-active', active);
        el.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      detailsRoot.removeAttribute('open');
    });
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const sortForm = document.getElementById('FacetsSortForm');

    const forms = [];
    const formEl = event.target.closest('form');
    const formId = formEl?.id;
    const isMobileFacetContext = formId === 'FacetFiltersFormMobile' || formId === 'FacetsSortForm';

    sortFilterForms.forEach((form) => {
      if (!isMobileFacetContext) {
        if (
          form.id === 'FacetSortForm' ||
          form.id === 'FacetsSortForm' ||
          form.id === 'FacetFiltersFormMobile'
        ) {
          forms.push(this.createSearchParams(form));
        }
      } else if (form.id === 'FacetFiltersFormMobile' || form.id === 'FacetsSortForm') {
        forms.push(this.createSearchParams(form));
      }
    });
    this.onSubmitForm(forms.join('&'), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.sortDrawerDelegated = false;
FacetFiltersForm.applyDelegated = false;
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
FacetFiltersForm.initSortDrawerModal();
FacetFiltersForm.initMobileFilterApply();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
